module.exports = __webpack_public_path__ + "img/item-03.a6e52f66.png";